var hashtag_default = {
  "fontElementMap": "-eNwY",
  "hashtag": "TxLFl"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
